module.exports = __webpack_public_path__ + "img/33_6.f107c6b4.png";